export type Colors = Readonly<{
    neutral900: string
    neutral700: string
    neutral500: string
    neutral300: string
    neutral100: string
    brand: string
    link: string
    link2: string
    success: string
    alert: string
    warning: string
    line: string
    brandBg: string
    linkBg: string
    successBg: string
    alertBg: string
    warningBg: string
    brandText: string
    successText: string
    alertText: string
    warningText: string
    disabledText: string
    linkText: string
    bluePrimary500: string
    primaryNeutral900: string
    lineDarkNeutral300: string
    appBackground: string
    surfaceBackground: string
    error600: string
    error50: string
    linkBg2: string

    flyinPrimary: string
    flyinSecondary: string
    flyinPrimaryText: string
    flyinSecondaryText: string
    hoverBg: string
    flyinChipText: string
    flyinChipBg: string
    flyinChipBorder: string
}>

const colors: Colors = {
    neutral900: '#1A1A1A',
    neutral700: '#808080',
    neutral500: '#B3B3B3',
    neutral300: '#F3F3F3',
    neutral100: '#FFFFFF',
    brand: '#E67B2E',
    link: '#0F6BFF',
    link2: '#3366CC',
    success: '#11A670',
    alert: '#DF9641',
    warning: '#C83232',
    line: '#E7E7E7',
    brandBg: '#FEF3ED',
    linkBg: '#EFF3FB',
    successBg: '#ECF8F4',
    alertBg: '#FCF7F0',
    warningBg: '#FBEFEF',
    brandText: '#FF4F17',
    successText: '#11A670',
    alertText: '#DF9641',
    warningText: '#C83232',
    disabledText: '#B3B3B3',
    linkText: '#36c',
    bluePrimary500: '#2A55E5',
    primaryNeutral900: '#212121',
    lineDarkNeutral300: '#E0E0E0',
    appBackground: '#F5F5F5',
    surfaceBackground: '#FFFFFF',
    error600: '#D23C33',
    error50: '#FBEBED',
    linkBg2: '#eff5fc',

    hoverBg: '#e5e7eb',

    flyinPrimary: '#FEC524',
    flyinSecondary: '#194e91',
    flyinPrimaryText: '#203152',
    flyinSecondaryText: '#7799BE',

    flyinChipText: '#4d6f93',
    flyinChipBg: '#4092fb',
    flyinChipBorder: '#CAD6E3'
    // flyinPrimaryText: '#FFFFFF',
    // flyinTertiary:'#000000',
}

export default colors
